var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTableView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10109_104619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5181 20.35H1.47313C1.22063 20.35 1.01562 20.0734 1.01562 19.7328V1.21492C1.01562 0.874244 1.22063 0.597656 1.47313 0.597656H22.5181C22.7706 0.597656 22.9756 0.874244 22.9756 1.21492V19.7328C22.9756 20.0734 22.7706 20.35 22.5181 20.35ZM1.93063 19.1155H22.0606V1.83218H1.93063V19.1155Z",
    fill: "#01537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5181 5.53531H1.47313C1.22063 5.53531 1.01562 5.25872 1.01562 4.91804C1.01562 4.57737 1.22063 4.30078 1.47313 4.30078H22.5181C22.7706 4.30078 22.9756 4.57737 22.9756 4.91804C22.9756 5.25872 22.7706 5.53531 22.5181 5.53531Z",
    fill: "#01537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5181 10.4728H1.47313C1.22063 10.4728 1.01562 10.1962 1.01562 9.85554C1.01562 9.51487 1.22063 9.23828 1.47313 9.23828H22.5181C22.7706 9.23828 22.9756 9.51487 22.9756 9.85554C22.9756 10.1962 22.7706 10.4728 22.5181 10.4728Z",
    fill: "#01537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5181 15.4103H1.47313C1.22063 15.4103 1.01562 15.1337 1.01562 14.793C1.01562 14.4524 1.22063 14.1758 1.47313 14.1758H22.5181C22.7706 14.1758 22.9756 14.4524 22.9756 14.793C22.9756 15.1337 22.7706 15.4103 22.5181 15.4103Z",
    fill: "#01537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8325 20.3496C8.58 20.3496 8.375 20.073 8.375 19.7323V4.91804C8.375 4.57737 8.58 4.30078 8.8325 4.30078C9.085 4.30078 9.29 4.57737 9.29 4.91804V19.7323C9.29 20.073 9.085 20.3496 8.8325 20.3496Z",
    fill: "#01537A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1977 20.3495C14.9452 20.3495 14.7402 20.0729 14.7402 19.7323V5.53523C14.7402 5.19456 14.9452 4.91797 15.1977 4.91797C15.4502 4.91797 15.6552 5.19456 15.6552 5.53523V19.7323C15.6552 20.0729 15.4502 20.3495 15.1977 20.3495Z",
    fill: "#01537A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10109_104619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTableView);
export default __webpack_public_path__ + "static/media/newTableView.c9c2d57c20f8aad321545ad0b49a8173.svg";
export { ForwardRef as ReactComponent };